export const APP_VERSION = '1.0.0';
export const APP_BUILD = 4;
export const APP_VERSION_LABEL = `v${APP_VERSION} (${APP_BUILD})`;
